import { getToken } from './auth';

// Rutas relativas — nginx hace el proxy /api/* -> backend en producción.
const API_BASE = '';

// Credenciales disponibles:
//  - x-api-key: clave máquina-a-máquina (opcional, build-time)
//  - x-auth-token: token de sesión del usuario logueado
function authHeaders() {
  const apiKey = process.env.REACT_APP_API_KEY || '';
  const token = getToken();
  return {
    ...(apiKey ? { 'x-api-key': apiKey } : {}),
    ...(token ? { 'x-auth-token': token } : {}),
  };
}

// Propaga el mensaje de error del backend en vez de un código pelado.
async function parseResponse(res) {
  const body = await res.json().catch(() => null);
  if (!res.ok) {
    const error = new Error(body?.error || `API error ${res.status}`);
    error.status = res.status;   // quien llama puede distinguir el motivo
    throw error;
  }
  return body;
}

// Fetch centralizado hacia el backend. Devuelve el JSON ya parseado y lanza en
// respuestas no-OK.
export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...authHeaders(),
      ...options.headers,
    },
  });
  return parseResponse(res);
}

// Sube un FormData. No se fija Content-Type a propósito: lo pone el navegador
// junto con el boundary del multipart.
export async function apiUpload(path, formData) {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  });
  return parseResponse(res);
}

// Descarga un fichero protegido. Se hace por fetch (no con un <a href>) para
// poder mandar el token en la cabecera en vez de exponerlo en la URL.
export async function apiDownload(path, filename) {
  const res = await fetch(`${API_BASE}${path}`, { headers: authHeaders() });
  if (!res.ok) {
    const body = await res.json().catch(() => null);
    throw new Error(body?.error || `API error ${res.status}`);
  }
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'archivo';
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}
